import * as e from "react";
const a = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "KG_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#KG_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#C51918"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "KG_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#KG_svg__b)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.982 17.867c.107 0 .214-.003.32-.009l.617 1.968.143-2.056c.206-.037.409-.085.607-.142l1.058 1.773-.339-2.034c.191-.083.377-.176.557-.278l1.443 1.485-.803-1.904c.166-.124.325-.257.477-.397l1.75 1.116-1.225-1.669c.133-.158.257-.323.373-.495l1.962.685-1.578-1.342c.092-.184.174-.374.247-.568l2.067.217-1.847-.945c.047-.2.083-.402.108-.61l2.062-.26-2.017-.497a5.958 5.958 0 00-.035-.619l1.944-.725-2.075-.022a5.88 5.88 0 00-.179-.595l1.72-1.149-2.021.453a5.928 5.928 0 00-.314-.54l1.406-1.51-1.86.903a6.02 6.02 0 00-.431-.454l1.016-1.79-1.6 1.303a5.997 5.997 0 00-.525-.345l.572-1.97-1.251 1.63a5.97 5.97 0 00-.593-.215l.098-2.046-.838 1.871a6.044 6.044 0 00-.628-.073L15.99 4l-.38 2.011a6.048 6.048 0 00-.63.072l-.837-1.869.098 2.041a5.965 5.965 0 00-.597.215l-1.247-1.625.57 1.963c-.184.106-.36.222-.53.346l-1.593-1.296 1.011 1.78a5.983 5.983 0 00-.436.458L9.57 7.2l1.397 1.5a5.896 5.896 0 00-.318.546l-2.009-.45 1.709 1.14c-.071.197-.132.399-.182.604l-2.06.022 1.93.72a5.939 5.939 0 00-.036.628l-2.002.493 2.046.259c.026.21.063.416.11.618l-1.833.938 2.052-.216c.074.197.158.39.252.575L9.057 15.91l1.95-.68c.117.173.243.34.377.5l-1.217 1.659 1.742-1.11c.153.141.314.275.482.4l-.8 1.895 1.437-1.48c.182.103.37.196.562.28l-.338 2.027 1.055-1.77c.2.058.403.105.61.142l.143 2.053.617-1.967c.101.005.203.008.305.008zm4.5-5.95c0 2.484-2.03 4.498-4.536 4.498-2.505 0-4.536-2.014-4.536-4.499s2.031-4.499 4.536-4.499c2.505 0 4.536 2.014 4.536 4.5zm-1.37 1.463c.188-.425.293-.896.293-1.391 0-.484-.1-.945-.281-1.363a5.357 5.357 0 00-1.984.525c1.194.523 1.735 1.383 1.971 2.23zm-.386.658a3.437 3.437 0 01-.32.371c-.065-1.18-.57-2.081-1.476-3.053 1.122.537 1.755 1.821 1.796 2.682zm-.86.812a3.515 3.515 0 01-.193.12c-.27-1.327-.779-2.374-1.488-3.21l.17-.13.07-.051c.909 1.044 1.481 1.94 1.442 3.271zm-1.89.568c.403 0 .79-.07 1.148-.197-.26-1.262-.715-2.438-1.372-3.286-.786.935-1.186 1.991-1.2 3.174.433.198.916.309 1.424.309zm-.66-3.889l.078.064c-.837.951-1.294 2.024-1.372 3.214a3.453 3.453 0 01-.296-.23c.315-1.258.838-2.296 1.59-3.048zm-2.498-.88c.786.089 1.407.28 1.871.501-1.184.504-1.651 1.314-1.886 2.142a3.42 3.42 0 01-.256-1.303c0-.475.096-.928.271-1.34zm.43 3.419a3.488 3.488 0 01-.077-.106c.06-.869.613-2.101 1.73-2.61-.75.728-1.31 1.556-1.652 2.716zm.254-4.454a3.42 3.42 0 012.474-1.054c.957 0 1.822.392 2.445 1.024-.98.113-1.81.359-2.484.74-.6-.344-1.413-.577-2.435-.71z",
      fill: "#FFDC17"
    }
  )))
), c = a;
export {
  c as default
};
